const appName = import.meta.env.VITE_APP_NAME || 'Roshan'

/** The tab's title: the page's own, or the site's name for a page that has none. */
export function pageTitle(title: string): string {
  return title || appName
}
